import React, { FC } from 'react';

type ServerVarsContextType = {
    isDesktop: boolean | null;
    isMobile: boolean | null;
    isSbAdsEnabled: boolean | null;
    isTablet: boolean | null;
    clientConf: object | null;
    localeOrigin: string | null;
    isSearchQueryApplied: boolean | null;
    isSmallerSbCategoryTilesVariant: boolean | null;
    isSbTopNavVariant: boolean | null;
};

export const ServerVarsContext = React.createContext<ServerVarsContextType>({
    isDesktop: null,
    isMobile: null,
    isSbAdsEnabled: null,
    isTablet: null,
    clientConf: {},
    localeOrigin: null,
    isSearchQueryApplied: null,
    isSmallerSbCategoryTilesVariant: null,
    isSbTopNavVariant: null,
});

export const ServerVarsContextConsumer = ServerVarsContext.Consumer;

export const ServerVarsContextProvider: FC<ServerVarsContextType> = ({
    children,
    isDesktop,
    isMobile,
    isSbAdsEnabled,
    isTablet,
    clientConf,
    localeOrigin,
    isSearchQueryApplied,
    isSmallerSbCategoryTilesVariant,
    isSbTopNavVariant,
}) => {
    return (
        <ServerVarsContext.Provider
            value={{
                isDesktop,
                isMobile,
                isSbAdsEnabled,
                isTablet,
                clientConf,
                localeOrigin,
                isSearchQueryApplied,
                isSmallerSbCategoryTilesVariant,
                isSbTopNavVariant,
            }}
        >
            {children}
        </ServerVarsContext.Provider>
    );
};
